import React from 'react';
import { Route, Switch } from 'react-router-dom';

import '../../index.css';
import ContentRegist from './ContentsMaking/ContentRegist';
import ImageRegist from './ContentsMaking/ImageRegist';
import MyVideoList from './ContentsMaking/MyVideoList';

function ContentsModal({ history, closeModal, isPaid }) {
  return (
    <Switch>
      <>
        <Route
          path="/mypage/contents-making/contents-modal/content-regist"
          render={() => (
            <ContentRegist
              history={history}
              closeModal={closeModal}
            ></ContentRegist>
          )}
        />
        <Route
          path="/mypage/contents-making/contents-modal/image-regist"
          render={() => (
            <ImageRegist
              history={history}
              closeModal={closeModal}
              isPaid={isPaid}
            ></ImageRegist>
          )}
        />

        <Route
          path="/mypage/contents-making/contents-modal/video-list"
          render={() => (
            <MyVideoList
              history={history}
              closeModal={closeModal}
            ></MyVideoList>
          )}
        />
      </>
    </Switch>
  );
}

export default ContentsModal;
